import { useCallback } from 'react';
import { useModal } from '@ebay/nice-modal-react';
import { useIntl } from 'react-intl';
import { Box } from '@mui/material';

import { useSnackbar } from '@ocx-app/lib/snackbar/snackbar';

import { ModalDrawer } from '@ocx/ui-modals';
import { SizingMultiplier } from '@ocx/ui';

import { useProfileCompletedActionSheet } from './profile-completed-action-sheet.hook';
import { EditProfileController } from './edit-profile.controller';
import { messages } from './edit-profile.messages';
import { EditProfilePopupProps } from './edit-profile-popup.types';

export const EditProfilePopupController = (props: EditProfilePopupProps) => {
  const { description } = props;
  const intl = useIntl();
  const snackbar = useSnackbar();
  const { open: openProfileCompletedPopup } = useProfileCompletedActionSheet();
  const { visible, hide, remove } = useModal();

  const handleProfileUpdated = useCallback(
    (params?: { isProfileCompletionTriggered?: boolean }) => {
      hide();

      if (params?.isProfileCompletionTriggered) {
        openProfileCompletedPopup();
      } else {
        snackbar.open(intl.formatMessage(messages.profileSubmitted), {
          variant: 'success',
        });
      }
    },
    [hide, intl, openProfileCompletedPopup, snackbar],
  );

  return (
    <ModalDrawer open={visible} onClose={hide} onExited={remove}>
      <Box p={SizingMultiplier.lg}>
        <EditProfileController description={description} onCancelClick={hide} onProfileUpdated={handleProfileUpdated} />
      </Box>
    </ModalDrawer>
  );
};
